import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { LOGIN_TYPES } from 'src/app/modules/login/models/login-types';
import { LOCAL_STORAGE_KEYS } from '../models/local-storage-keys';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(
    private _router: Router,
    private _authService: AuthService,
    private jwtHelper: JwtHelperService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.guardDefaultBehaviour(route, state);
  };

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.guardDefaultBehaviour(route, state);
  };

  private getDefaultUrl(): UrlTree {
    const isExternalUser = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE) === LOGIN_TYPES.EXTERNAL;
    return this._router.parseUrl(isExternalUser ? '/loginext' : '/login');
  }

  private guardDefaultBehaviour(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    // data from the route config in the daata property
    const allowRoles: string[] = (route.data.allowRoles ?? []).map(r => r.toUpperCase());
    const rejectRoles: string[] = (route.data.rejectRoles ?? []).map(r => r.toUpperCase());

    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
    // Decode token to get roles
    const tokenPayload = this.jwtHelper.decodeToken(token);
    const userRoles: string[] = (tokenPayload?.roles ?? []).map(r => r.toUpperCase());

    if (
      !this._authService.isLoggedIn()
      || userRoles.some(role => rejectRoles.includes(role))
      || (allowRoles.length && !userRoles.find(role => allowRoles.includes(role)))
    ) {
      return this.getDefaultUrl();
    } else {
      return true;
    }
  };
}
